import { render, staticRenderFns } from "./AllListComponent.vue?vue&type=template&id=18f772f4&scoped=true&"
import script from "./AllListComponent.vue?vue&type=script&lang=js&"
export * from "./AllListComponent.vue?vue&type=script&lang=js&"
import style0 from "./AllListComponent.vue?vue&type=style&index=0&id=18f772f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f772f4",
  null
  
)

export default component.exports